export default __webpack_public_path__ + "static/media/U_Urso.68bbd898.mp3";